import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface IParcelaAPagarPrevisaoCompra {
  np: number;
  vencimento: string;
  valorDoc: number;
}

export const ObterFormaDePagamentoDetalhada = async (
  codPrevisaoCompra: number,
  codLoja: number
): Promise<IParcelaAPagarPrevisaoCompra[]> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IParcelaAPagarPrevisaoCompra[]>(
      `/obter-forma-de-pagamento-detalhada-da-previsao`,
      { params: { codPrevisaoCompra, codLoja, token } }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter os detalhes da forma de pagamento da previsão"
    );
  }
};